module.exports = __webpack_public_path__ + "img/shuttle-central-illus.c128a322.png";